export default __webpack_public_path__ + "static/media/house_black.a751a1d5.png";